module.exports = __webpack_public_path__ + "static/bulb_icon-f234eb91dd3d9af508c21dd351fb8aac.svg";